import { type IconSettings } from '@tabler/icons-vue';
import type { RouteLocationRaw } from 'vue-router';

export enum BreadcrumbItem {
  CONTROLLER = 'Controller',
  CONTROLLERS = 'Controllers',
  ORGANIZATIONS = 'Organizations',
  ORGANIZATION = 'Organization',
}

export interface BreadcrumbsProps {
  items?: BreadcrumbItem[];
}

export interface Breadcrumb {
  label: string;
  to: RouteLocationRaw;
  subitem?: {
    icon: typeof IconSettings;
    to: RouteLocationRaw;
  };
}
